import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';
import { OrderReportsResponse } from '../../types/order/order-reports/order-reports.type';

export type GetOrderReportsRequest = {
  search?: string;
  orderTypes?: string[];
  orderStatuses?: string[];
  shippingMethods?: string[];
  ataModelIds?: number[];
  enclosureModelIds?: number[];
  routerModelIds?: number[];
  simModelIds?: number[];
  year?: number;
  months?: number[];
  startDate?: string;
  endDate?: string;
  fromWarehouseIds?: number[];
  toWarehouseIds?: number[];
};

export const getOrderReportsData = createAsyncThunk<
  OrderReportsResponse,
  { data: GetOrderReportsRequest },
  { state: RootReducerState }
>('orderReports/getOrderReportsData/no-loader', async ({ data }, thunkAPI) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/inventory/order-report`, data);
    return response.data;
  } catch (error) {
    return rejectWithApiError({
      thunkAPI,
      error,
      fallback: 'Error during fetching order report!',
    });
  }
});
